const getGif = (id) => (
  `https://i.giphy.com/media/${id}/giphy.gif`
);

export default getGif;
